(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~switch"],{

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var utils_props_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var utils_vue_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
var _excluded = ["disabled", "size", "tabIndex"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// import "./style/index.scss";


var Switch = {
  name: "MegSwitch",
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    prefixCls: utils_vue_types__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].string,
    disabled: utils_vue_types__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].bool.def(false),
    checkedChildren: utils_vue_types__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].any,
    unCheckedChildren: utils_vue_types__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].any,
    size: utils_vue_types__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].oneOf(["small", "default", "large"]),
    tabIndex: utils_vue_types__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].oneOfType([utils_vue_types__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].string, utils_vue_types__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].number]),
    checked: utils_vue_types__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].bool.def(false),
    defaultChecked: utils_vue_types__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].bool.def(false),
    autoFocus: utils_vue_types__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].bool.def(false)
  },
  data: function data() {
    var checked = false;

    if (Object(utils_props_util__WEBPACK_IMPORTED_MODULE_0__["hasProp"])(this, "checked")) {
      checked = !!this.checked;
    } else {
      checked = !!this.defaultChecked;
    }

    return {
      stateChecked: checked
    };
  },
  watch: {
    checked: function checked(val) {
      this.stateChecked = val;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var autoFocus = _this.autoFocus,
          disabled = _this.disabled;

      if (autoFocus && !disabled) {
        _this.focus();
      }
    });
  },
  methods: {
    setChecked: function setChecked(checked, e) {
      if (this.disabled) {
        return;
      }

      if (!Object(utils_props_util__WEBPACK_IMPORTED_MODULE_0__["hasProp"])(this, "checked")) {
        this.stateChecked = checked;
      }

      this.$emit("change", checked, e);
    },
    handleClick: function handleClick(e) {
      var checked = !this.stateChecked;
      this.setChecked(checked, e);
      this.$emit("click", checked, e);
    },
    handleKeyDown: function handleKeyDown(e) {
      if (e.keyCode === 37) {
        // Left
        this.setChecked(false, e);
      } else if (e.keyCode === 39) {
        // Right
        this.setChecked(true, e);
      }
    },
    handleMouseUp: function handleMouseUp(e) {
      if (this.$refs.refSwitchNode) {
        this.$refs.refSwitchNode.blur();
      }

      this.$emit("mouseup", e);
    },
    focus: function focus() {
      this.$refs.refSwitchNode.focus();
    },
    blur: function blur() {
      this.$refs.refSwitchNode.blur();
    }
  },
  render: function render() {
    var _switchClassName, _wrapperClassName;

    var h = arguments[0];
    // get component name
    var prefixCls = this.$options.name.replace(/\B([A-Z])/g, "-$1").toLowerCase();

    var _getOptionProps = Object(utils_props_util__WEBPACK_IMPORTED_MODULE_0__["getOptionProps"])(this),
        disabled = _getOptionProps.disabled,
        size = _getOptionProps.size,
        tabIndex = _getOptionProps.tabIndex,
        restProps = _objectWithoutProperties(_getOptionProps, _excluded);

    var checked = this.stateChecked;
    var switchClassName = (_switchClassName = {}, _defineProperty(_switchClassName, prefixCls, true), _defineProperty(_switchClassName, "".concat(prefixCls, "-small"), size === "small"), _defineProperty(_switchClassName, "".concat(prefixCls, "-checked"), checked), _defineProperty(_switchClassName, "".concat(prefixCls, "-disabled"), disabled), _switchClassName);
    var spanProps = {
      props: _objectSpread({}, restProps),
      on: _objectSpread(_objectSpread({}, Object(utils_props_util__WEBPACK_IMPORTED_MODULE_0__["getListeners"])(this)), {}, {
        keydown: this.handleKeyDown,
        click: this.handleClick,
        mouseup: this.handleMouseUp
      }),
      attrs: {
        type: "button",
        role: "switch",
        "aria-checked": checked,
        disabled: disabled,
        tabIndex: tabIndex
      },
      class: switchClassName,
      ref: "refSwitchNode"
    };
    var wrapperClassName = (_wrapperClassName = {}, _defineProperty(_wrapperClassName, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_wrapperClassName, "".concat(prefixCls, "-wrapper-small"), size === "small"), _defineProperty(_wrapperClassName, "".concat(prefixCls, "-disabled"), disabled), _wrapperClassName);
    return h("span", {
      "class": wrapperClassName
    }, [Object(utils_props_util__WEBPACK_IMPORTED_MODULE_0__["getComponentFromProp"])(this, "checkedChildren") && h("span", {
      "class": "".concat(prefixCls, "-label ").concat(prefixCls, "-label-left ").concat(checked ? "".concat(prefixCls, "-label-select") : ' ')
    }, [Object(utils_props_util__WEBPACK_IMPORTED_MODULE_0__["getComponentFromProp"])(this, "checkedChildren")]), h("button", spanProps), Object(utils_props_util__WEBPACK_IMPORTED_MODULE_0__["getComponentFromProp"])(this, "checkedChildren") && h("span", {
      "class": "".concat(prefixCls, "-label ").concat(prefixCls, "-label-right ").concat(!checked ? "".concat(prefixCls, "-label-select") : ' ')
    }, [Object(utils_props_util__WEBPACK_IMPORTED_MODULE_0__["getComponentFromProp"])(this, "unCheckedChildren")])]);
  }
};

Switch.install = function (Vue) {
  Vue.component(Switch.name, Switch);
};

/* harmony default export */ __webpack_exports__["default"] = (Switch);

/***/ })

}]);